import React from 'react';
import { TrendingUp, Mic, Volume2 } from 'lucide-react';

const PopularCommands = () => {
  const commands = [
    {
      id: 1,
      command: "Open Spotify and play 'Good Morning' playlist, set volume to 40, open Chrome",
      category: "Morning Routine",
      uses: "2,847"
    },
    {
      id: 2,
      command: "Open VS Code and Spotify, then play 'Baby' by Justin Bieber",
      category: "Coding Session",
      uses: "1,923"
    },
    {
      id: 3,
      command: "Search for React hooks documentation on Chrome and arrange VS Code and Chrome side by side",
      category: "Learning",
      uses: "3,156"
    },
    {
      id: 4,
      command: "Search for Python asyncio tutorial, open new tab, search for FastAPI documentation",
      category: "Research",
      uses: "1,678"
    },
    {
      id: 5,
      command: "Open Notepad, maximize it, then copy 'TODO: Fix authentication bug' to clipboard",
      category: "Quick Note",
      uses: "892"
    },
    {
      id: 6,
      command: "Open Photoshop and Chrome side by side, then play my creative playlist",
      category: "Creative Work",
      uses: "1,234"
    }
  ];

  return (
    <section id="popular-commands" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 mb-4">
            <TrendingUp className="w-6 h-6 text-orange-500" />
            <span className="text-orange-500 font-semibold uppercase tracking-wider text-sm">
              Community Favorites
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Top Daily-Used Commands
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Real voice workflows from 10,000+ power users. Just speak naturally - no typing needed.
          </p>
        </div>

        {/* Voice Instruction */}
        <div className="mb-12 max-w-3xl mx-auto">
          <div className="bg-gradient-to-r from-orange-500/10 to-red-500/10 border border-orange-500/30 rounded-xl p-6">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 animate-pulse">
                <Mic className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-white font-semibold mb-1">How to use:</h3>
                <p className="text-gray-300 text-sm">
                  Press your mic button and say any of these commands naturally. Twe will understand and execute them instantly.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Commands Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {commands.map((item, index) => (
            <div
              key={item.id}
              className="group relative bg-zinc-900/50 backdrop-blur-sm border border-white/5 rounded-xl p-6 hover:border-orange-500/50 transition-all duration-300 hover:transform hover:scale-[1.02]"
            >
              {/* Category Badge */}
              <div className="flex items-center justify-between mb-4">
                <span className="px-3 py-1 bg-orange-500/10 text-orange-500 text-xs font-semibold rounded-full border border-orange-500/20">
                  {item.category}
                </span>
                <div className="flex items-center space-x-2 text-gray-400 text-sm">
                  <TrendingUp className="w-4 h-4" />
                  <span>{item.uses} uses</span>
                </div>
              </div>

              {/* Voice Icon */}
              <div className="flex items-start space-x-3 mb-4">
                <div className="mt-1">
                  <Volume2 className="w-5 h-5 text-orange-500" />
                </div>
                <div className="flex-1">
                  <p className="text-gray-300 leading-relaxed">
                    "{item.command}"
                  </p>
                </div>
              </div>

              {/* Visual indicator */}
              <div className="flex items-center space-x-2 text-sm text-gray-500">
                <div className="flex space-x-1">
                  <div className="w-1 h-4 bg-orange-500/30 rounded"></div>
                  <div className="w-1 h-5 bg-orange-500/50 rounded"></div>
                  <div className="w-1 h-6 bg-orange-500/70 rounded"></div>
                  <div className="w-1 h-5 bg-orange-500/50 rounded"></div>
                  <div className="w-1 h-4 bg-orange-500/30 rounded"></div>
                </div>
                <span className="text-xs">Voice command example</span>
              </div>

              {/* Hover Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/0 via-orange-500/5 to-orange-500/0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 mb-4">
            Want to see more? Explore our full automation library
          </p>
          <a
            href="/recipes"
            className="inline-flex items-center space-x-2 text-orange-500 hover:text-orange-400 font-medium transition-colors duration-200"
          >
            <span>View All Recipes</span>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PopularCommands;